import styled, { css } from "styled-components";

export const ColorSquare = styled.div<{color:string}>`
    &:hover{
      opacity: 1;
      transform: scale(1.1);
      z-index: 2;
    }
    width:2rem;
    height:2rem;

    background-color: ${(props) => props.color};
`;

export const colorsContainer = css`
    &.MuiGrid-root {
        margin-bottom:5px;
        gap:0.2rem;
    }
`;
